<template>
  <RevDrawer :name :title="i18n(translations.modalTitle)">
    <template #trigger="{ open }">
      <RevLink
        class="caption-bold mt-20 flex items-center text-left"
        @click="open"
      >
        <IconInfo class="mr-4" size="16" />
        {{ i18n(translations.modalTrigger) }}
      </RevLink>
    </template>

    <template #body>
      <p>{{ i18n(translations.modalFirstText) }}</p>
      <p class="mt-24">{{ i18n(translations.modalSecondText) }}</p>
      <p class="body-1-bold mt-24">{{ i18n(translations.modalNote) }}</p>

      <RevLink
        v-if="hasLegalModalLink"
        class="mt-16 block"
        target="_blank"
        :to="pdfLink"
      >
        {{ i18n(translations.modalLegalLink) }}
      </RevLink>
    </template>
  </RevDrawer>
</template>

<script lang="ts" setup>
import { useRoute, useRuntimeConfig } from '#imports'
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { RevDrawer } from '@ds/components/Drawer'
import { RevLink } from '@ds/components/Link'
import { IconInfo } from '@ds/icons/IconInfo'

import { useRouteLocationWithLocale } from '~/composables/useRouteLocationWithLocale'
import { CMS } from '~/scopes/cms/routes-names'
import { LEGAL_PAGE_NAME } from '~/scopes/legal/constants'

import translations from './LegalModal.translations'

const i18n = useI18n()
const country = useMarketplace().market.countryCode
const route = useRoute()
const resolveLocalizedRoute = useRouteLocationWithLocale()
const {
  public: { FF_COUNTRIES_WITH_REVIEWS_LEGAL_MODAL_PAGE_LINK },
} = useRuntimeConfig()

const hasLegalModalLink =
  FF_COUNTRIES_WITH_REVIEWS_LEGAL_MODAL_PAGE_LINK?.includes(country)

const name = computed(() => `REVIEWS_LEGAL_INFORMATION_${route.name as string}`)

const pdfLink = resolveLocalizedRoute({
  name: CMS.LEGAL_PAGE,
  params: {
    pageName: LEGAL_PAGE_NAME.OTHER,
  },
})
</script>
